import { MainframeService } from '@amzn/awscat-portfolio-assessment-service-client';
import { StoredMainframe } from '@amzn/awscat-portfolio-assessment-types';
import { FlashContextInterface, FlashType, withFlashContext } from '@amzn/awscat-react-components';
import { Alert, Box, Button, Container, Header, SpaceBetween, Spinner } from '@amzn/awsui-components-react';
import { useEffect, useState } from 'react';
import { match, useHistory, useRouteMatch } from 'react-router';
import { useIsMounted } from 'react-tidy';

import { constants } from '../../common/Localization';
import { MatchParam } from '../../common/types';
import PreviewBanner from '../common/PreviewBanner';
import MainframeEntry from './mainframe/MainframeEntry';

type Props = FlashContextInterface;
const mainframeService = new MainframeService();
function MainframePage({ flash }: Props): JSX.Element {
    const match: match<MatchParam> | null = useRouteMatch({
        path: '/portfolio/:portfolioId',
    });
    const portfolioId = match?.params?.portfolioId || '';
    const [ mainframes, setMainframes ] = useState<StoredMainframe[]>([]);
    const [ loading, setLoading ] = useState(false);
    const isMounted = useIsMounted();
    const history = useHistory();
    const loadMainframes = async () => {
        try {
            setLoading(true);
            const result = await mainframeService.list(portfolioId);
            if (isMounted()) {
                setMainframes(result);
            }
        } catch (err) {
            if (isMounted()) {
                flash.alert(FlashType.error, (err as Error).message, constants.FAILED_TO_LOAD_MAINFRAMES);
            }
        } finally {
            if (isMounted()) {
                setLoading(false);
            }
        }
    };
    useEffect(() => {
        loadMainframes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const redirectToCreate = () => {
        history.push(`/portfolio/${portfolioId}/management/assets/mainframe/create`);
    };
    const mainframeList = mainframes.map(mainframe => {
        return (
            <MainframeEntry
                key={mainframe.id}
                mainframe={mainframe}
                portfolioId={portfolioId}
                reloadMainframes={loadMainframes} />
        );
    });
    let mainframeEntries: JSX.Element = <div>{mainframeList}</div>;
    if (mainframes.length === 0) {
        mainframeEntries = (
            <Container>
                <SpaceBetween size='m'>
                    <Box textAlign='center'>
                        {constants.YOU_HAVE_NOT_YET_MAINFRAMES}
                    </Box>
                    <Box textAlign='center'>
                        <Button variant='primary' onClick={redirectToCreate}>{constants.CREATE_WORKLOAD}</Button>
                    </Box>
                </SpaceBetween>
            </Container>
        );
    }
    return (
        <SpaceBetween size='l'>
            <PreviewBanner customHeader={constants.MAINFRAME_PREVIEW}></PreviewBanner>
            <Alert header={constants.MAINFRAME_IS_SEPARATE_FROM_MAIN_TCO}>
                <span>
                    {constants.MAINFRAME_ALERT_1}<em> {constants.ASSETS} &gt; {constants.MAINFRAMES}</em>
                    {constants.MAINFRAME_ALERT_2}<em> {constants.TCO} &gt; {constants.MAINFRAME_SUMMARY}</em>
                    {constants.MAINFRAME_ALERT_3}
                    {constants.MAINFRAME_ALERT_4}<em> {constants.TCO} &gt; {constants.TCO_SUMMARY}</em>
                    {constants.MAINFRAME_ALERT_5}
                </span>
            </Alert>
            <Header actions={
                <Button onClick={redirectToCreate} variant='primary' iconName='add-plus'>{constants.CREATE_WORKLOAD}</Button>
            } variant='h1'>{constants.MAINFRAME_WORKLOADS}</Header>
            { loading ? <Spinner size='large'></Spinner> : mainframeEntries }
        </SpaceBetween>
    );
}

export default withFlashContext(MainframePage);
